import React from 'react'
import CouponManager from '../components/CouponsForm'

const CouponsScreen = () => {
  return (
    <CouponManager/>
  )
}

export default CouponsScreen